__turbopack_context__.v({
  "avatar": "Header-module-scss-module__wS1-Va__avatar",
  "avatarButton": "Header-module-scss-module__wS1-Va__avatarButton",
  "avatarNotification": "Header-module-scss-module__wS1-Va__avatarNotification",
  "control": "Header-module-scss-module__wS1-Va__control",
  "controlButton": "Header-module-scss-module__wS1-Va__controlButton",
  "controlButtonHiddenMd": "Header-module-scss-module__wS1-Va__controlButtonHiddenMd",
  "controlLink": "Header-module-scss-module__wS1-Va__controlLink",
  "controls": "Header-module-scss-module__wS1-Va__controls",
  "controlsSkeleton": "Header-module-scss-module__wS1-Va__controlsSkeleton",
  "createAccountButton": "Header-module-scss-module__wS1-Va__createAccountButton",
  "fade-in": "Header-module-scss-module__wS1-Va__fade-in",
  "header": "Header-module-scss-module__wS1-Va__header",
  "headerContent": "Header-module-scss-module__wS1-Va__headerContent",
  "headerScrolled": "Header-module-scss-module__wS1-Va__headerScrolled",
  "link": "Header-module-scss-module__wS1-Va__link",
  "logo": "Header-module-scss-module__wS1-Va__logo",
  "nav": "Header-module-scss-module__wS1-Va__nav",
  "navButton": "Header-module-scss-module__wS1-Va__navButton",
  "no-transform": "Header-module-scss-module__wS1-Va__no-transform",
  "rotate": "Header-module-scss-module__wS1-Va__rotate",
  "savedItemsNav": "Header-module-scss-module__wS1-Va__savedItemsNav",
  "search": "Header-module-scss-module__wS1-Va__search",
  "specificity-boost": "Header-module-scss-module__wS1-Va__specificity-boost",
});
